/**
 * A creative's picture until the image system exists (R18, spec §9): a 48 px placeholder drawn by format. It takes no
 * URL and reads no thumbnail; the next spec fills it with cached Meta and TikTok images. Decorative: the format is
 * written on the line under the name, so a screen reader hears it once.
 *
 * @module components/creatives/CreativeThumb
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { GalleryHorizontal, HelpCircle, Image, Shapes, Video, type LucideIcon } from 'lucide-react';
import { creativeFormatLabel, type CreativeFormat } from '@/services/creatives/creativeFormat';

const ICON: Readonly<Record<CreativeFormat, LucideIcon>> = { static: Image, video: Video, carousel: GalleryHorizontal, other: Shapes };

export const CreativeThumb: React.FC<{ format: CreativeFormat | null }> = ({ format }) => {
  const { t } = useTranslation();
  const Icon = format === null ? HelpCircle : ICON[format];
  return (
    <span
      aria-hidden="true" data-creative-thumb={format ?? 'none'} title={creativeFormatLabel(format, t)}
      className="inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-neutral-100 text-neutral-700"
    >
      <Icon className="h-5 w-5" />
    </span>
  );
};
